import { API_ROOT } from '../../config/config'
import { doDelete, doDownload, doGet, doPost, doPostDownload, doPostFiles } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

export const getExpenseRequest = (projectCode, periodNo, id) => {
  const url = `${API_ROOT}/v1/accounting/expense-request/${projectCode}/${periodNo}?accountingBorrowAvanceId=${
    id || ''
  }`
  return doGet(url)
}

export const saveExpenseRequest = (request) => {
  const url = `${API_ROOT}/v1/accounting/expense-request/save`
  return doPost(url, request)
}

export const deleteExpenseRequest = (id) => {
  const url = `${API_ROOT}/v1/accounting/expense-request/${id}`
  return doDelete(url)
}

export const downloadExpenseRequestAttachments = (fileId) => {
  const url = `${API_ROOT}/v1/accounting/expense-request/attachments/download/${fileId}`
  return doDownload(url)
}

export const downloadExpenseRecordVoucherFile = (accountingExpensesId) => {
  const url = `${API_ROOT}/files/${accountingExpensesId}/payment/voucher/form`
  return doDownload(url)
}
